export default __webpack_public_path__ + "static/media/img--design-2.0630363f.jpg";